<template>
  <div class="data-wrap">
    <div class="data-tab" v-if="gameIdx > 0">
      <div class="tab-item" v-for="(i, idx) in gameIdx" :class="{ 'active': idx === activeGameIdx }" :key="`${i}-${idx}`"
        @click="changeTab(idx)">第{{ i | numToCN }}局</div>
    </div>
    <div class="data-content">
      <template v-if="!isDataLoading && activeGameInfo && activeGameInfo.home && activeGameInfo.home.team">
        <div class="info">
          <div class="kill">
            <div class="home">
              <div class="team" :class="[isHomeRed ? 'home-red' : 'home-blue']">
                <img :src="activeGameInfo.home.team.team_logo" @error="onKogTeamLogoError" alt="" />
                <span>{{ activeGameInfo.home.team.team_name }}</span>
                <img class="success-icon" v-if="activeGameInfo.home.team.is_win"
                  src="../../../assets/images/gaming/success-icon.png" alt="">
              </div>
            </div>
            <div class="img">
              <div class="kill-count">{{ activeGameInfo.home.team.kill_count }}</div>
              <img src="../../../assets/images/gaming/duizhan-icon.png" alt="">
              <div class="kill-count">{{ activeGameInfo.away.team.kill_count }}</div>
            </div>
            <div class="away">
              <div class="team" :class="[isHomeRed ? 'away-blue' : 'away-red']">
                <img :src="activeGameInfo.away.team.team_logo" @error="onKogTeamLogoError" alt="" />
                <span>{{ activeGameInfo.away.team.team_name }}</span>
                <img class="success-icon" v-if="activeGameInfo.away.team.is_win"
                  src="../../../assets/images/gaming/success-icon.png" alt="">
              </div>
            </div>
          </div>
          <div class="event">
            <div class="home">
              <img class="fudai-icon" src="../../../assets/images/gaming/fudai-icon.png" alt="">
              <span class="money">{{ activeGameInfo.home.team.money | formatNumber }}</span>
              <img class="event-img" v-if="activeGameInfo.home.team.is_first_blood"
                src="../../../assets/images/gaming/first_blood-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.home.team.is_first_tower"
                src="../../../assets/images/gaming/first_tower-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.home.team.is_five_kills"
                src="../../../assets/images/gaming/five_kills-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.home.team.is_ten_kills"
                src="../../../assets/images/gaming/ten_kills-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.home.team.is_first_tyrants"
                src="../../../assets/images/gaming/first_small_dragon-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.home.team.is_first_dominates"
                src="../../../assets/images/gaming/first_big_dragon-pre.png" alt="">
            </div>
            <div class="time">{{ activeCoverInfo.duration | secToMin }}</div>
            <div class="away">
              <img class="event-img" v-if="activeGameInfo.away.team.is_first_blood"
                src="../../../assets/images/gaming/first_blood-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.away.team.is_first_tower"
                src="../../../assets/images/gaming/first_tower-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.away.team.is_five_kills"
                src="../../../assets/images/gaming/five_kills-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.away.team.is_ten_kills"
                src="../../../assets/images/gaming/ten_kills-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.away.team.is_first_tyrants"
                src="../../../assets/images/gaming/first_small_dragon-pre.png" alt="">
              <img class="event-img" v-if="activeGameInfo.away.team.is_first_dominates"
                src="../../../assets/images/gaming/first_big_dragon-pre.png" alt="">
              <span class="money">{{ activeGameInfo.away.team.money | formatNumber }}</span>
              <img class="fudai-icon" src="../../../assets/images/gaming/fudai-icon.png" alt="">
            </div>
          </div>
          <div class="money-line">
            <img :style="{ left: `calc(${(homeMoneyRate * 100 + '%')} - 15px)` }"
              src="../../../assets/images/gaming/vs-icon.png" alt="">
            <div class="home"
              :class="[activeGameInfo.home.team.side - 0 ? 'home-red-team-color' : 'home-blue-team-color']"
              :style="{ width: homeMoneyRate * 100 + '%' }"></div>
            <div class="away"
              :class="[activeGameInfo.away.team.side - 0 ? 'away-red-team-color' : 'away-blue-team-color']"
              :style="{ width: awayMoneyRate * 100 + '%' }"></div>
          </div>
          <div class="ban-pick">
            <div class="ban-list">
              <div class="home">
                <template v-for="(i, idx) in 5">
                  <div class="ban-avatar" v-if="activeGameInfo.home.ban[idx]" :key="`${i.name}-${idx}`">
                    <img class="avatar" :key="`${i.name}-${idx}`" :src="activeGameInfo.home.ban[idx].avatar"
                      @error="banImgError" alt="" />
                  </div>
                  <img v-else :key="`default-${i.name}-${idx}`" src="../../../assets/images/gaming/member-ban.png"
                    alt="" />
                </template>
              </div>
              <div class="title">BAN</div>
              <div class="away">
                <template v-for="(i, idx) in 5">
                  <div class="ban-avatar" v-if="activeGameInfo.away.ban[idx]" :key="`${i.name}-${idx}`">
                    <img class="avatar" :key="`${i.name}-${idx}`" :src="activeGameInfo.away.ban[idx].avatar"
                      @error="banImgError" alt="" />
                  </div>
                  <img v-else :key="`default-${i.name}-${idx}`" src="../../../assets/images/gaming/member-ban.png"
                    alt="" />
                </template>
              </div>
            </div>
            <div class="pick-list">
              <div class="home">
                <template v-for="(i, idx) in 5">
                  <div class="ban-avatar" v-if="activeGameInfo.home.hero[idx]" :key="`${i.name}-${idx}`">
                    <img class="avatar" :key="`${i.name}-${idx}`" :src="activeGameInfo.home.hero[idx].avatar"
                      @error="pickImgError" alt="" />
                  </div>
                  <img v-else :key="`default-${i.name}-${idx}`" src="../../../assets/images/gaming/member-pick.png"
                    alt="" />
                </template>
              </div>
              <div class="title">PICK</div>
              <div class="away">
                <template v-for="(i, idx) in 5">
                  <div class="ban-avatar" v-if="activeGameInfo.away.hero[idx]" :key="`${i.name}-${idx}`">
                    <img class="avatar" :key="`${i.name}-${idx}`" :src="activeGameInfo.away.hero[idx].avatar"
                      @error="pickImgError" alt="" />
                  </div>
                  <img v-else :key="`default-${i.name}-${idx}`" src="../../../assets/images/gaming/member-pick.png"
                    alt="" />
                </template>
              </div>
            </div>
          </div>
          <div class="process-wrap">
            <div class="process-list">
              <div class="process-item-wrap">
                <div class="process-item">
                  <div class="home">{{ activeGameInfo.home.team.tyrants_count }}</div>
                  <div class="process-info">
                    <el-progress type="circle" :width="100" stroke-linecap="butt" :show-text="false" :stroke-width="15"
                      :define-back-color="isHomeRed ? '#ff4b3a' : '#48b2fb'" :color="isHomeRed ? '#48b2fb' : '#ff4b3a'"
                      :percentage="smallDragonPercentage * 100"></el-progress>
                  </div>
                  <div class="away">{{ activeGameInfo.away.team.tyrants_count }}</div>
                </div>
                <div class="name">暴君</div>
              </div>
              <div class="process-item-wrap">
                <div class="process-item">
                  <div class="home">{{ activeGameInfo.home.team.dominates_count }}</div>
                  <div class="process-info">
                    <el-progress type="circle" :width="100" stroke-linecap="butt" :show-text="false" :stroke-width="15"
                      :define-back-color="isHomeRed ? '#ff4b3a' : '#48b2fb'" :color="isHomeRed ? '#48b2fb' : '#ff4b3a'"
                      :percentage="bigDragonPercentage * 100"></el-progress>
                  </div>
                  <div class="away">{{ activeGameInfo.away.team.dominates_count }}</div>
                </div>
                <div class="name">主宰</div>
              </div>
              <div class="process-item-wrap">
                <div class="process-item">
                  <div class="home">{{ activeGameInfo.home.team.tower_success_count }}</div>
                  <div class="process-info">
                    <el-progress type="circle" :width="100" stroke-linecap="butt" :show-text="false" :stroke-width="15"
                      :define-back-color="isHomeRed ? '#ff4b3a' : '#48b2fb'" :color="isHomeRed ? '#48b2fb' : '#ff4b3a'"
                      :percentage="towerSuccessPercentage * 100"></el-progress>
                  </div>
                  <div class="away">{{ activeGameInfo.away.team.tower_success_count }}</div>
                </div>
                <div class="name">推塔</div>
              </div>
              <div class="process-item-wrap">
                <div class="process-item">
                  <div class="home">{{ activeGameInfo.home.team.money | formatNumber }}</div>
                  <div class="process-info">
                    <el-progress type="circle" :width="100" stroke-linecap="butt" :show-text="false" :stroke-width="15"
                      :define-back-color="isHomeRed ? '#ff4b3a' : '#48b2fb'" :color="isHomeRed ? '#48b2fb' : '#ff4b3a'"
                      :percentage="crystalPercentage * 100"></el-progress>
                  </div>
                  <div class="away">{{ activeGameInfo.away.team.money | formatNumber }}</div>
                </div>
                <div class="name">经济</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="money">
          <div class="title">经济差</div>
          <MoneyChart :diff="activeDiff" :homeName="homeName" :awayName="awayName"/>
        </div> -->
        <div class="member">
          <div class="member-list">
            <div class="member-title" :class="[activeGameInfo.home.team.side - 0 ? 'red' : 'blue']">
              <div class="name">{{ activeGameInfo.home.team.side - 0 ? '红' : '蓝' }}方-{{ activeGameInfo.home.team.team_name
                }}
              </div>
              <div class="hero">英雄</div>
              <div class="kda">KDA</div>
              <div class="offered-rate">参战率</div>
              <div class="money">经济</div>
              <div class="damage-count">输出</div>
              <div class="damage-taken-count">承伤</div>
              <div class="prod">出装</div>
            </div>
            <template v-for="(player, idx) in activeGameInfo.home.player">
              <GameMemberItem :key="`${player.player_id}-${idx}`" :player="player" :coverInfo="coverInfo" />
            </template>
          </div>

          <div class="member-list">
            <div class="member-title" :class="[activeGameInfo.away.team.side - 0 ? 'red' : 'blue']">
              <div class="name">{{ activeGameInfo.away.team.side - 0 ? '红' : '蓝' }}方-{{ activeGameInfo.away.team.team_name
                }}
              </div>
              <div class="hero">英雄</div>
              <div class="kda">KDA</div>
              <div class="offered-rate">参战率</div>
              <div class="money">经济</div>
              <div class="damage-count">输出</div>
              <div class="damage-taken-count">承伤</div>
              <div class="prod">出装</div>
            </div>
            <template v-for="(player, idx) in activeGameInfo.away.player">
              <GameMemberItem :key="`${player.player_id}-${idx}`" :player="player" :coverInfo="coverInfo"
                :homeTeamSide="activeGameInfo.home.team.side" />
            </template>
          </div>
        </div>
      </template>
      <div class="page-loading" v-if="isDataLoading">
        <div class="img-wrap">
          <img src="//static.fly2a.com/static/image/f-jiazai-min.png" />
        </div>
      </div>
      <div class="empty-page"
        v-if="!(activeGameInfo && activeGameInfo.home && activeGameInfo.home.team) && !isDataLoading">
        <img src="../../../assets/images/gaming/empty-game.png" alt="">
        <p>暂无数据！</p>
      </div>
    </div>
  </div>
</template>

<script>
import GameMemberItem from './gameMemberItem.vue'
import MoneyChart from './moneyChart.vue'

export default {
  name: 'GameData',
  components: {
    GameMemberItem, MoneyChart
  },
  props: {
    coverInfo: {
      type: Object
    },
    gameInfo: {
      type: Object
    },
    activeGameIdx: {
      type: Number
    },
    moreGameData: {
      type: Object
    },
    moreCoverInfo: {
      type: Object
    },
    diffInfo: {
      type: Object
    },
    moreDiffInfo: {
      type: Object
    },
    isDataLoading: {
      type: Boolean
    }
  },
  data() {
    return {
    }
  },
  computed: {
    homeName() {
      return this.coverInfo.home_team_name
    },
    awayName() {
      return this.coverInfo.away_team_name
    },
    gameIdx() {
      return this.coverInfo.game_count
    },
    smallDragonCount() {
      if (this.isLastIdx) {
        return this.gameInfo.home.team.tyrants_count + this.gameInfo.away.team.tyrants_count
      } else {
        return this.activeGameInfo.home.team.tyrants_count + this.activeGameInfo.away.team.tyrants_count
      }
    },
    smallDragonPercentage() {
      if (this.isLastIdx) {
        if (this.gameInfo.away.team.tyrants_count === 0 && this.gameInfo.home.team.tyrants_count > 0) {
          return 0
        }
        return this.gameInfo.away.team.tyrants_count / this.smallDragonCount > 0 ? this.gameInfo.away.team.tyrants_count / this.smallDragonCount : 0.5
      } else {
        if (this.activeGameInfo.away.team.tyrants_count === 0 && this.activeGameInfo.home.team.tyrants_count > 0) {
          return 0
        }
        return this.activeGameInfo.away.team.tyrants_count / this.smallDragonCount > 0 ? this.activeGameInfo.away.team.tyrants_count / this.smallDragonCount : 0.5
      }
    },
    bigDragonCount() {
      if (this.isLastIdx) {
        return this.gameInfo.home.team.dominates_count + this.gameInfo.away.team.dominates_count
      } else {
        return this.activeGameInfo.home.team.dominates_count + this.activeGameInfo.away.team.dominates_count
      }
    },
    bigDragonPercentage() {
      if (this.isLastIdx) {
        if (this.gameInfo.away.team.dominates_count === 0 && this.gameInfo.home.team.dominates_count > 0) {
          return 0
        }
        return this.gameInfo.away.team.dominates_count / this.bigDragonCount > 0 ? this.gameInfo.away.team.dominates_count / this.bigDragonCount : 0.5
      } else {
        if (this.activeGameInfo.away.team.dominates_count === 0 && this.activeGameInfo.home.team.dominates_count > 0) {
          return 0
        }
        return this.activeGameInfo.away.team.dominates_count / this.bigDragonCount > 0 ? this.activeGameInfo.away.team.dominates_count / this.bigDragonCount : 0.5
      }
    },
    towerSuccessCount() {
      if (this.isLastIdx) {
        return this.gameInfo.home.team.tower_success_count + this.gameInfo.away.team.tower_success_count
      } else {
        return this.activeGameInfo.home.team.tower_success_count + this.activeGameInfo.away.team.tower_success_count
      }
    },
    towerSuccessPercentage() {
      if (this.isLastIdx) {
        if (this.gameInfo.away.team.tower_success_count === 0 && this.gameInfo.home.team.tower_success_count > 0) {
          return 0
        }
        return this.gameInfo.away.team.tower_success_count / this.towerSuccessCount > 0 ? this.gameInfo.away.team.tower_success_count / this.towerSuccessCount : 0.5
      } else {
        if (this.activeGameInfo.away.team.tower_success_count === 0 && this.activeGameInfo.home.team.tower_success_count > 0) {
          return 0
        }
        return this.activeGameInfo.away.team.tower_success_count / this.towerSuccessCount > 0 ? this.activeGameInfo.away.team.tower_success_count / this.towerSuccessCount : 0.5
      }
    },
    crystalCount() {
      if (this.isLastIdx) {
        return this.gameInfo.home.team.money + this.gameInfo.away.team.money
      } else {
        return this.activeGameInfo.home.team.money + this.activeGameInfo.away.team.money
      }
    },
    crystalPercentage() {
      if (this.isLastIdx) {
        if (this.gameInfo.away.team.money === 0 && this.gameInfo.home.team.money > 0) {
          return 0
        }
        return this.gameInfo.away.team.money / this.crystalCount > 0 ? this.gameInfo.away.team.money / this.crystalCount : 0.5
      } else {
        if (this.activeGameInfo.away.team.money === 0 && this.activeGameInfo.home.team.money > 0) {
          return 0
        }
        return this.activeGameInfo.away.team.money / this.crystalCount > 0 ? this.activeGameInfo.away.team.money / this.crystalCount : 0.5
      }
    },
    isLastIdx() {
      return this.coverInfo.game_count === (this.activeGameIdx + 1)
    },
    activeCoverInfo() {
      if (this.isLastIdx) {
        return this.coverInfo
      } else {
        return this.moreCoverInfo[this.activeGameIdx]
      }
    },
    activeGameInfo() {
      if (this.isLastIdx) {
        return this.gameInfo
      } else {
        return this.moreGameData[this.activeGameIdx]
      }
    },
    moneyCount() {
      return this.activeGameInfo.home.team.money + this.activeGameInfo.away.team.money
    },
    homeMoneyRate() {
      return (!this.moneyCount || this.moneyCount === 0) ? 0.5 : this.activeGameInfo.home.team.money / this.moneyCount
    },
    awayMoneyRate() {
      return (!this.moneyCount || this.moneyCount === 0) ? 0.5 : this.activeGameInfo.away.team.money / this.moneyCount
    },
    activeDiff() {
      if (this.isLastIdx) {
        const diffObj = {
          x: [],
          y: []
        }

        const diffInfo = this.diffInfo
        if (diffInfo && diffInfo.diff) {
          const diffStr = diffInfo.diff
          const diffArr = diffStr.split(',')

          diffArr.forEach(i => {
            diffObj.x.push(Number(i.split(':')[0] || 0))
            diffObj.y.push(Number(i.split(':')[1] || 0))
          })
        }
        return diffObj
      } else {
        const diffObj = {
          x: [],
          y: []
        }

        const diffInfo = this.moreDiffInfo[this.activeGameIdx]
        if (diffInfo && diffInfo.diff) {
          const diffStr = diffInfo.diff
          const diffArr = diffStr.split(',')

          diffArr.forEach(i => {
            diffObj.x.push(i.split(':')[0])
            diffObj.y.push(i.split(':')[1])
          })
        }
        return diffObj
      }
    },
    isHomeRed() {
      if (this.isLastIdx) {
        return (this.gameInfo.home?.team?.side || 0) - 0
      } else {
        return this.activeGameInfo.home.team.side - 0
      }
    }
  },
  filters: {
    secToMin(sec) {
      // 将秒数除以60，得到分钟数
      let min = sec / 60;
      // 使用 Math.floor 方法向下取整
      min = Math.floor(min);
      const second = sec % 60 < 10 ? '0' + sec % 60 : sec % 60
      // 返回结果
      return `${min}:${second}`;
    },
    numToCN(num) {
      // 定义一个数组存储汉字
      const CN_CHARS = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      // 定义一个字符串存储结果
      let result = "";
      // 定义一个变量存储位数
      let digit = 0;
      // 使用一个循环遍历数字的每一位
      while (num > 0) {
        // 取出数字的最后一位
        let last = num % 10;
        // 根据位数和值拼接汉字
        if (digit === 0) {
          // 个位
          result = CN_CHARS[last] + result;
        } else if (digit === 1) {
          // 十位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加十和对应的汉字
            result = "十" + CN_CHARS[last] + result;
          }
        } else if (digit === 2) {
          // 百位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加百和对应的汉字
            result = "百" + CN_CHARS[last] + result;
          }
        }
        // 将数字除以10，去掉最后一位
        num = Math.floor(num / 10);
        // 将位数加一
        digit++;
      }
      // 返回结果
      return result;
    },
    formatNumber(num) {
      return num >= 1000 ? (num / 1000).toFixed(1) + 'k' : num;
    }
  },
  methods: {
    changeTab(tab) {
      this.$emit('tabChange', {
        type: 'gameData',
        idx: tab
      })
    }
  },
}
</script>

<style lang="less" scoped>
.data-wrap {
  .data-tab {
    display: flex;
    height: 66px;
    background: #fff;
    border-radius: 5px;

    .tab-item {
      flex: 1;
      text-align: center;
      line-height: 66px;
      color: #13161B;
      font-size: 22px;
      cursor: pointer;

      &.active {
        color: #E65668;
      }
    }
  }

  .data-content {
    .info {
      padding: 52px 134px 50px;
      background: #fff;
      margin-top: 20px;
      box-shadow: 0px 3px 7px 0px rgba(205, 57, 67, 0.2);
      border-radius: 4px;

      .kill {
        display: flex;
        gap: 48px;
        align-items: center;
        justify-content: space-between;
        margin-left: -134px;
        margin-right: -134px;

        .img {
          width: 134px;
          height: 34px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width: 34px;
            height: 34px;
          }

          .kill-count {
            font-size: 18px;
          }
        }

        .home,
        .away {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .team {
            position: relative;
            height: 98px;
            width: 255px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            img {
              width: 52px;
              height: 52px;
              display: block;
              background: #fff;
              border-radius: 4px;
              padding: 2px;
            }

            span {
              display: block;
              font-size: 16px;
              text-align: center;
              color: #fff;
              margin-top: 5px;
              line-height: 18px;
              font-weight: bold;
            }

            .success-icon {
              position: absolute;
              width: 48px;
              height: 28px;
              top: 4px;
              background: transparent;
              border-radius: 0;
              padding: 0;
            }
          }

          .home-red {
            &::before {
              position: absolute;
              content: '';
              left: 0;
              height: 100%;
              top: 0;
              width: 14px;
              background: #E43325;
            }

            background: linear-gradient(-90deg, rgba(47, 103, 191, 0) 0%, rgba(202, 0, 43, .65) 100%);
          }

          .home-blue {
            &::before {
              position: absolute;
              content: '';
              left: 0;
              height: 100%;
              top: 0;
              width: 14px;
              background: #3E89FF;
            }

            background: linear-gradient(-90deg, rgba(47, 103, 191, 0) 0%, rgba(0, 93, 238, 0.65) 100%);
          }

          .away-red {
            &::before {
              position: absolute;
              content: '';
              right: 0;
              height: 100%;
              top: 0;
              width: 14px;
              background: #E43325;
            }

            background: linear-gradient(90deg, rgba(47, 103, 191, 0) 0%, rgba(202, 0, 43, .65) 100%);
          }

          .away-blue {
            &::before {
              position: absolute;
              content: '';
              right: 0;
              height: 100%;
              top: 0;
              width: 14px;
              background: #3E89FF;
            }

            background: linear-gradient(90deg, rgba(47, 103, 191, 0) 0%, rgba(0, 93, 238, 0.65) 100%);
          }
        }

        .home {
          .success-icon {
            left: 150px;
          }
        }

        .away {
          .success-icon {
            right: 150px;
          }
        }
      }

      .event {
        display: flex;
        align-items: center;
        margin-top: 50px;

        .time {
          font-size: 16px;
        }

        .home,
        .away {
          flex: 1;
          display: flex;
          align-items: center;

          .fudai-icon {
            width: 23px;
            height: 23px;
          }

          .money {
            color: #FFA347;
            font-size: 14px;
            margin: 0 5px;
          }

          .event-img {
            width: 23px;
            height: 23px;
          }
        }

        .away {
          justify-content: end;
        }
      }

      .money-line {
        height: 12px;
        position: relative;
        border-radius: 12px;
        margin-top: 10px;

        .home,
        .away {
          height: 12px;
          position: absolute;
          top: 0;
        }

        .home {
          left: 0;
          border-top-left-radius: 12px;
          border-bottom-left-radius: 12px;
        }

        .away {
          right: 0;
          border-top-right-radius: 12px;
          border-bottom-right-radius: 12px;
        }

        img {
          position: absolute;
          top: -7px;
          width: 30px;
          height: 26px;
          z-index: 1;
        }
      }

      .ban-pick {
        padding: 20px 0 36px;
        border-bottom: 1px solid #ECECEC;

        .ban-list,
        .pick-list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;

          .home,
          .away {
            display: flex;
            gap: 7px;

            img {
              width: 46px;
              height: 46px;
              border-radius: 5px;
            }
          }

          .away {
            justify-content: end;
            flex-direction: row-reverse;
          }

          .title {
            font-size: 17px;
          }
        }

        .ban-list {

          .home,
          .away {
            .ban-avatar {
              background-image: url('../../../assets/images/gaming/ban-hero-border.png');
              background-repeat: no-repeat;
              background-size: 100%;
              padding: 2px;
              border-radius: 9px;
              overflow: hidden;
            }

            .avatar {
              filter: grayscale(100%);
              width: 42px;
              height: 42px;
              border-radius: 9px;
            }
          }
        }

        .pick-list {

          .home,
          .away {
            .ban-avatar {
              background-image: url('../../../assets/images/gaming/pick-hero-border.png');
              background-repeat: no-repeat;
              background-size: 100%;
              padding: 2px;
              border-radius: 9px;
              overflow: hidden;
            }

            .avatar {
              width: 42px;
              height: 42px;
              border-radius: 9px;
            }
          }
        }
      }

      .process-wrap {
        align-items: center;
        margin-top: 50px;

        .process-list {
          display: flex;
          justify-content: space-between;

          .process-item {
            display: flex;
            align-items: center;
            gap: 10px;

            .process-info {
              width: 100px;
              height: 100px;
            }

            .home,
            .away {
              font-size: 16px;
            }
          }

          .name {
            text-align: center;
            margin-top: 20px;
          }
        }

        .process-title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 38px;
          margin-top: 50px;

          .home,
          .away {
            display: flex;
            align-items: center;

            img {
              width: 38px;
              height: 38px;
            }

            .line {
              width: 57px;
              height: 28px;

              &.blue {
                background: linear-gradient(90deg, #2F67BF 0%, rgba(47, 103, 191, 0) 100%);
              }

              &.red {
                background: linear-gradient(90deg, rgba(171, 17, 54, 0) 0%, #B30E31 100%);
              }
            }
          }
        }
      }
    }

    >.money {
      padding: 40px 48px;
      background: #fff;
      margin-top: 20px;
      box-shadow: 0px 3px 7px 0px rgba(205, 57, 67, 0.2);

      .title {
        text-align: center;
        font-size: 22px;
        line-height: 30px;
        margin-bottom: 30px;
      }
    }

    .member {
      margin-top: 20px;

      .member-list {
        margin-bottom: 20px;

        .name {
          width: 126px;
          margin-right: 10px;
        }

        .hero {
          width: 125px;
        }

        .kda {
          width: 92px;
        }

        .offered-rate {
          width: 64px;
          margin-right: 45px;
        }

        .money {
          width: 72px;
          margin-right: 16px;
        }

        .damage-count {
          width: 72px;
          margin-right: 16px;
        }

        .damage-taken-count {
          width: 72px;
          margin-right: 14px;
        }

        .prod {
          width: 282px;
        }

        .member-title {
          display: flex;
          color: #fff;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;

          &.red {
            background: #E65869
          }

          &.blue {
            background: #2E2ECA;
          }

          div {
            height: 54px;
            text-align: center;
            line-height: 54px;
            font-size: 17px;
          }
        }
      }
    }
  }
}

.home-red-team-color {
  background: linear-gradient(-90deg, #F55E1D 0%, #D40C2D 100%);
}

.home-blue-team-color {
  background: linear-gradient(-90deg, #78EFF9 0%, #3069C1 100%);
}

.away-red-team-color {
  background: linear-gradient(90deg, #F55E1D 0%, #D40C2D 100%);
}

.away-blue-team-color {
  background: linear-gradient(90deg, #78EFF9 0%, #3069C1 100%);
}

.page-loading {
  min-height: 50vh;
  position: relative;

  .img-wrap {
    position: absolute;
    left: 50%;
    top: 200px;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 150px;
    height: 150px;
    background: rgba(0, 0, 0, .1);
    border-radius: 50%;

    img {
      margin: 55px 0 0 20px;
      animation: jiazai 4s ease-in-out infinite forwards;
    }
  }
}

.empty-page {
  img {
    display: block;
    width: 50%;
    margin: 80px auto;
  }

  p {
    text-align: center;
    font-size: 16px;
    position: relative;
    top: -150px;
  }
}
</style>
